import { Route, Routes, Outlet } from 'react-router-dom'
import { TelekitsListWrapper } from './telekits-list/TelekitsList'
import { PageTitle } from '_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { TelekitDetalhe } from './detalhe/TelekitDetalhe'

const TelekitsPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.telekits.descricao')}>
                {t('menu.telekits')}
              </PageTitle>
              <TelekitsListWrapper />
            </>
          }
        />
        <Route
          path=':id'
          element={
            <>
              <PageTitle description={t('pagina.telekits.dispositivos.descricao')}>
                {t('menu.telekits')}
              </PageTitle>
              <TelekitDetalhe />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default TelekitsPage
